import React, { useEffect, useState } from 'react'
import { RoutineDataList } from './components/RoutineDataList'
import { useLocation } from 'react-router-dom'
import { SubHeader } from '../../../components/SubHeader'
import api from '../../../services/api'
import { Button } from '../../../components/Button'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../redux/hooks'
import { initialBreadcrumb } from '../../../redux/reducers/breadcrumb/actions'
import { Stack } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { RoutineForm } from './components/RoutineForm'
import { InputSearch } from '../../../components/InputSearch'
import { TreatEmpty } from 'components/TreatEmpty'
import { LoadingPage } from 'components/LoadingPage'
import { showMessage } from 'redux/reducers/snackbar/snackbar.actions'
import { Add } from '@mui/icons-material'
import { Routine } from 'models/interfaces/routine.interface'
import { TreatEmptySuggestion } from 'components/TreatEmptySuggestion'

export const RoutineList = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { t } = useTranslation()
  const [data, setData] = useState<Routine[]>([])
  const [dataSearch, setDataSearch] = useState<Routine[]>([])
  const [modalVisible, setModalVisible] = useState(false)
  const [routine, setRoutine] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [showInstruction, setShowInstruction] = useState<boolean>(false)

  useEffect(() => {
    const body = document.querySelector('body')
    if (body) {
      body.style.overflow = modalVisible ? 'hidden' : 'auto'
    }
    dataFetch().catch(console.error)
  }, [modalVisible])

  useEffect(() => {
    if (location.state?.showInstruction) {
      setShowInstruction(true)
    }
  }, [location.state])

  const dataFetch = async () => {
    dispatch(initialBreadcrumb({ label: t('header.title.trainingBench'), path: location.pathname }))
    setLoading(true)
    try {
      const { data } = await api.get('routines')
      setData(data)
      setDataSearch(data)
      setShowInstruction(data.length > 0 ? false : true)
    } catch {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    } finally {
      setLoading(false)
    }
  }

  const handleOpenModal = () => {
    setRoutine(null)
    setModalVisible(!modalVisible)
  }

  const handleSearchField = (searchReturn: any) => {
    setDataSearch(searchReturn)
  }

  const handleEdit = (routine: any) => {
    setRoutine(routine)
    setModalVisible(routine)
  }

  return (
    <>
      <Helmet>
        <title> Routine | DWF </title>
      </Helmet>
      <Stack>
        <SubHeader path={location.pathname} goBack={false} />
        <RoutineForm
          isVisible={modalVisible}
          routine={routine}
          onSubmitted={async () => {
            setModalVisible(false)
            await dataFetch()
          }}
          onClose={() => setModalVisible(false)}
          loading={loading}
        />
        <>
          <Stack
            mb={{ xs: 2, sm: 0, md: 0 }}
            spacing={1}
            justifyContent="space-between"
            direction={{ xs: 'column', sm: 'row' }}
          >
            <Stack flex={1}>
              <InputSearch
                title={`${t('search.title')}`}
                data={data}
                params={['labels', 'name', 'note']}
                action={handleSearchField} />
            </Stack>
            <Stack
              direction={{ xs: 'column', sm: 'row', md: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center', md: 'center' }}
              spacing={2}
            >
              <Button
                title={`${t('routine.newRoutine')}`}
                startIcon={<Add />}
                onClick={handleOpenModal}
              />
            </Stack>
          </Stack>
          { loading
            ? <LoadingPage />
            : <>
              { data && data.length === 0
                ? <TreatEmptySuggestion
                  textSuggestion={[
                    t('routine.title.suggestion_1'),
                    t('routine.title.suggestion_2', { newRoutine: t('routine.newRoutine') }),
                    t('routine.title.suggestion_3')
                  ]}
                  showInstruction={showInstruction}
                />
                : dataSearch.length === 0
                  ? <TreatEmpty subTitleMessage={t('general.searchEmpty')} />
                  : <RoutineDataList items={dataSearch} onEdit={handleEdit} />
              }
            </>
          }
        </>
      </Stack>
    </>
  )
}
